module.exports = __webpack_public_path__ + "static/img/ddhzyk-img12.904343eb.jpg";